module.exports = __webpack_public_path__ + "f5c09089677c67ccb35007b190372cec.svg";